// Default value for vial, if no autosampler or device is Cromite.
export const DEFAULT_VIAL = 'A1';
